function isTypingInInput() {
  const activeElement = document.activeElement;
  return activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT';
}

export function customHistoryBack() {
  const signInUrl = window.location.protocol + '//' + window.location.hostname + '/sign-in';
  const statusReportUrl = window.location.protocol + '//' + window.location.hostname + '/status-report';
  const currentPage = window.location.href;

  const previousPage = sessionStorage.getItem('previousPage');

  if (previousPage) {
    if (previousPage.includes(signInUrl)) {
      window.location.href = window.location.protocol + '//' + window.location.hostname;
      return;
    }

    if (previousPage.includes(statusReportUrl)) {
      window.location.href = previousPage;
      return;
    }

    history.back();
    return;
  }

  history.back();
}

function setupBackButton() {
  const backButton = document.getElementById('backBtn');
  if (backButton) {
    backButton.addEventListener('click', customHistoryBack);
  }
}

function handleBackNavigation() {
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
    if (window.location.pathname === '/status-report/') {
      customHistoryBack();
    }
  }
}

function setupBackspaceNavigation() {
  window.addEventListener('keydown', function(event) {
    if ((event.key === 'Backspace' || event.keyCode === 8) && !isTypingInInput()) {
      customHistoryBack();
    }
  });
}

function capturePreviousPageOnLoad() {
  const signInUrl = window.location.protocol + '//' + window.location.hostname + '/sign-in';
  const currentPage = window.location.href;

  // Remove the previous page from session storage if the current page is the home page
//   const isHomePage = window.location.pathname === '/';
//   if (isHomePage) {
//     sessionStorage.removeItem('previousPage');
//   }

  if (currentPage.includes(signInUrl)) {
    sessionStorage.setItem('previousPage', currentPage);
  }
}

export function initReturnBackLogic() {
  window.addEventListener('load', () => {
    capturePreviousPageOnLoad();
    setupBackButton();
    handleBackNavigation();
  });

  setupBackspaceNavigation();
}



// WEBPACK FOOTER //
// ./scripts/util/returnBack.js